if (!customElements.get('wingpass-rich-content')) {
  customElements.define('wingpass-rich-content', class extends HTMLElement {
    connectedCallback() {
      if (!this.hasAttribute('data-policy-layout') || this.querySelector('.wingpass-policy-nav')) return;
      const headings = [...this.querySelectorAll('h2')];
      if (!headings.length) return;
      const nav = document.createElement('nav');
      nav.className = 'wingpass-policy-nav';
      nav.setAttribute('aria-label', 'On this page');
      const select = document.createElement('select');
      select.className = 'wingpass-policy-select';
      select.setAttribute('aria-label', 'On this page');
      headings.forEach((heading, index) => {
        const title = heading.textContent.trim();
        heading.id = `${this.closest('[id]').id}-clause-${index + 1}`;
        const link = document.createElement('a');
        link.href = `#${heading.id}`;
        link.textContent = title;
        nav.append(link);
        select.add(new Option(title, heading.id));
        const match = title.match(/^(\d+\.)\s*(.*)$/);
        if (match) {
          const number = document.createElement('span');
          number.className = 'wingpass-policy-number';
          number.textContent = match[1];
          const label = document.createElement('span');
          label.textContent = match[2];
          heading.replaceChildren(number, label);
        }
      });
      this.prepend(nav, select);
      this.onSelect = () => document.getElementById(select.value)?.scrollIntoView({behavior: 'smooth'});
      select.addEventListener('change', this.onSelect);
      this.onScroll = () => {
        let active = headings[0];
        for (const heading of headings) if (heading.getBoundingClientRect().top <= 140) active = heading;
        nav.querySelectorAll('a').forEach(link => {
          if (link.hash === `#${active.id}`) link.setAttribute('aria-current', 'location');
          else link.removeAttribute('aria-current');
        });
        select.value = active.id;
      };
      window.addEventListener('scroll', this.onScroll, {passive: true});
      this.onScroll();
    }
    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      this.querySelector('select')?.removeEventListener('change', this.onSelect);
      this.querySelector('.wingpass-policy-nav')?.remove();
      this.querySelector('.wingpass-policy-select')?.remove();
    }
  });
}
